<template>
    <div class="card__title" :class="[sizeString ? 'text-' + sizeString : '', colorString ? 'text-' + colorString : '', {'justify-center text-center': center, 'justify-end': right, 'pb-8': spacedContent}]">
        <slot/>
    </div>
</template>

<script>
import Sizeable from "../../mixins/Sizeable";
    import Colorable from "../../mixins/Colorable";
    import Alignable from "../../mixins/Alignable";

    export default {
        name: "CardTitle",

        mixins: [Sizeable, Colorable, Alignable],

        props: {
            // Whether the card title has some content with additional spacing right below it
            // which causes a too large overall spacing between the title and the content.
            // Therefore, setting this to true will decrease the bottom spacing of the title.
            spacedContent: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style>
/*********************
  Inputs
**********************/
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.card .card__title {
  font-size: 16px;
  padding: 20px 24px;
  font-weight: 600;
  line-height: 1.2;
  font-family: "proxima-nova", "Trebuchet MS", Helvetica, sans-serif;
  letter-spacing: normal;
  color: #2e3535;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  word-break: break-word;
}
.card .card__title h2, .card .card__title h3, .card .card__title h4, .card .card__title h5, .card .card__title h6 {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 0;
}
@media (max-width: 1023px) {
  .card .card__title {
    padding: 16px;
  }
}
.card.card-small .card__title {
  font-size: 15px;
  padding: 16px;
}
.card.card-small .card__title h2, .card.card-small .card__title h3, .card.card-small .card__title h4, .card.card-small .card__title h5, .card.card-small .card__title h6 {
  font-size: 15px;
}
.card.card-x-small .card__title {
  font-size: 14px;
  padding: 12px;
}
.card.card-x-small .card__title h2, .card.card-x-small .card__title h3, .card.card-x-small .card__title h4, .card.card-x-small .card__title h5, .card.card-x-small .card__title h6 {
  font-size: 14px;
}
@media (max-width: 1023px) {
  .card.card-x-small .card__title {
    font-size: 12px;
    padding: 8px;
  }
}
.card.is-dark .card__title {
  color: #ffffff;
}
</style>